/**
 *
 * @tableOfContent
 *  1. doc ready / window resize / init functions
 *  2. responsive images
 *  3. toggling footer cols on mobile devices
 *
 */

/**
 *   @section 1. doc ready / window resize / init functions
 *   @section 2. responsive Images
 *   @section 3. carousel
 **/

// doc ready
$(function () {
    var cookies;
    function readCookie(name,c,C,i){
        if(cookies){ return cookies[name]; }
        c = document.cookie.split('; ');
        cookies = {};
        for(i=c.length-1; i>=0; i--){
            C = c[i].split('=');
            cookies[C[0]] = C[1];
        }
        return cookies[name];
    }
    window.readCookie = readCookie;
    function createCookie(name,value,days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    // toggle footer cols
    toggleFooterCols();


    // Third Level Navigation Slide
    //http://www.bootply.com/QhA0MPMKtI
    initSliderLevelNav();

    // Responsive Images
    initResponsiveImages();

    // Slider Tour: add Lightbox to Images
    initTourSliderLightbox();

    // get alt from image for magnific popup
    magnificPopup();

    // Headerslider / Header carousel: carousel indicators in Desktop Version verlinkt
    dataHrefToHref();

    //initDatepicker
    initDatepicker();

    //toggleEyecatcher();
    toggleEyecatcher();

    //bootstrap carousel swipe on touch devicesusr_p388561_1.sqlusr_p388561_1.sql
    carouselTouchSwipe();

    //focus highlight setzen
    focusHighlighting();

    // if mobile menu is open add class menu-open to body
    mobileMenuIsOpen();

    // setze aria-label mit allen h3 an aside
    setAttrToAside();

    // lösche aria Attribute bei Accordion
    deleteAttrFromAccordion();

    $('#changeCookieSettings').on('click', function () {
        // Cookie löschen
        emptyCookies();
    })

    // Cookies akzeptieren
    acceptCookies();

    // Nach dem Neuladen zur ersten Umfrage springen
    jumpToPoll();

    $(window).on('load', function(){
        // Funktion zum Gleichsetzen der Höhen von Inhaltselementen
        equalheight('> .slider .teaser, > [class*="col-"] .teaser, > .slider blockquote');
    });

    // on window resize
    $(window).on('resize', function(){
        equalheight('> .slider .teaser, > [class*="col-"] .teaser, > .slider blockquote');

        // toggle footer cols
        toggleFooterCols();

        // Funktion mobileMenuIsOpen() aufrufen
        mobileMenuIsOpen();
    });


    // GoogleMap.initialize();

    // Übersetzung von JQuery UI Autocomplete
    var L = $('#tx-solr-search-form-pi-results [name="L"]').val();
    switch (L) {
        case '0': // german
            $.ui.autocomplete.prototype.options.messages = {
                noResults: 'Keine Suchergebnisse gefunden.',
                results: function( amount ) {
                    return amount + ( amount > 1 ? ' Ergebnisse sind' : ' Ergebnis ist' ) +
                        ' verfügbar. Nutzen Sie die "Hoch"- und "Runter"-Pfeiltaten zur Navigation.';
                }
            };
            break;
    }
});

var cookiesSet = false;

/**
 * Initialize Datepicker
 */
function initDatepicker() {

    var $datepicker = $('.datepicker');

    $datepicker.datepicker({
        firstDayOfWeek: 1, // The first day of week is Monday
        outputFormat: 'dd.MM.yyyy'
    });

}

/**
 *    @section 2. responsive Images
 **/
function initResponsiveImages() {

    if (typeof(XIMA) != "undefined") {
        XIMA.api.responsiveImages.run(
            '.xm-responsive-images:has(img[data-srcset]),.csc-textpic-image:has(img[data-srcset]),.teaser:has(img[data-srcset]),.headerimage:has(img[data-srcset]), .headerslider:has(img[data-srcset]), .slider:has(img[data-srcset])',
            'img[data-srcset]'
        );
    }
}

/**
 *   @section 2. toggling footer cols on mobile devices
 **/
function toggleFooterCols(){

    jQuery(".collapsingFooterHeadline").each(function (i,e) {
        //variables
        var togglingHeadline = jQuery(e);
        var togglingFooterCol = togglingHeadline.closest('.csc-default').next(".collapsingFooterCol");
        var collapsingFooterColID = togglingFooterCol.attr('id');
        var togglingHeadlineLink = '<a href="#' + collapsingFooterColID + '" class="collapsingFooterHead" data-toggle="collapse" aria-expanded="false" aria-controls="' + collapsingFooterColID +'">';


        togglingHeadline.click(function(e) {
            e.preventDefault();
        });

        if($(window).width() <= 767){
            togglingHeadline.wrap(function() {
                return togglingHeadlineLink  + "</a>";
            });

            togglingFooterCol.addClass("collapse");

        }else{
            if(togglingHeadline.closest('a').length) {
                var cscDefault = togglingHeadline.closest('.csc-default');

                togglingHeadline.closest('a').remove();
                cscDefault.prepend(togglingHeadline);
            }

            togglingFooterCol.removeClass("collapse");
            togglingFooterCol.removeAttr("style");
        }
    });
}

function initSliderLevelNav(){
    var scrollValue = 200;
    var scrollOffset = 5;

    // each scroll arrows
    $('.scroll-arrows').each(function (index, element) {
        var $scrollElement = $(element),
            $scrollButtons = $scrollElement.find('> .scroll-arrows-button'),
            $scrollButtonRight = $scrollElement.find('> .scroll-arrows-button-right'),
            $scrollButtonLeft = $scrollElement.find('> .scroll-arrows-button-left'),
            $scrollContainer = $scrollElement.find('> .scroll-arrows-container'),
            $scrollInner = $scrollContainer.find('> .scroll-arrows-inner');

        // click arrow buttons
        $scrollButtons.on('click', function () {
            var $button = $(this),
                scroll;

            if($button.hasClass('scroll-arrows-button-right')) {
                // right scroll
                scroll = scrollValue;
            } else {
                // left scroll
                scroll = -scrollValue;
            }

            // animate scroll
            $scrollContainer.animate({
                scrollLeft: $scrollContainer.scrollLeft() + scroll
            });
        });

        // compare menu width with container width and show arrows
        setTimeout(function(){
            _showScroller($scrollContainer, $scrollInner, $scrollButtonRight, $scrollButtonLeft);
        }, 100);

        // on menu scroll ...
        $scrollContainer.on('scroll', debouncer(function(){
            // ... show scroller
            _showScroller($scrollContainer, $scrollInner, $scrollButtonRight, $scrollButtonLeft);
        }));

        // on window resize ...
        $(window).on('resize', debouncer(function(){
            // ... show scroller
            _showScroller($scrollContainer, $scrollInner, $scrollButtonRight, $scrollButtonLeft);
        }));

        // observe bitv tool
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutationRecord) {
                // ... show scroller
                _showScroller($scrollContainer, $scrollInner, $scrollButtonRight, $scrollButtonLeft);
            });
        });
        var target = $scrollContainer[0];
        observer.observe(target, { attributes : true, attributeFilter : ['style'] });

        function _showScroller($scrollContainer, $scrollInner, $scrollButtonRight, $scrollButtonLeft) {
            var scrollInnerWidth = 0;

            // get inner width
            $scrollInner.find('> li').each(function(index, element){
                scrollInnerWidth += $(element).outerWidth();
            });

            scrollInnerWidth = parseInt(scrollInnerWidth)

            // show / hide 'left' button
            if( parseInt($scrollContainer.scrollLeft()) === 0) {
                $scrollButtonLeft.removeClass('active');
            } else {
                $scrollButtonLeft.addClass('active');
            }

            // show / hide 'right' button
            if(parseInt($scrollInner.outerWidth()) + parseInt($scrollContainer.scrollLeft()) + scrollOffset >= scrollInnerWidth) {
                $scrollButtonRight.removeClass('active');
            } else {
                $scrollButtonRight.addClass('active');
            }
        }
    });
}

// debouncer
function debouncer(func, timeout) {
    /**
     * "Auspendeln" von Ereignissen wie $(window).resize()
     * http://stackoverflow.com/a/4298672/574120
     * @param  function func    Funktion, die ausgeführt werden soll, sobald timeout abgelaufen ist
     * @param  int      timeout Zeitraum, nachdem die Funktion ausgeführt werden soll
     */
    var timeoutID , timeout = timeout || 200;
    return function () {
        var scope = this , args = arguments;
        clearTimeout( timeoutID );
        timeoutID = setTimeout( function () {
            func.apply( scope , Array.prototype.slice.call( args ) );
        } , timeout );
    }
}

function initTourSliderLightbox() {
    $('.slider.tour').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery:{
            enabled:true
        },
        image: {
            // options for image content type
            titleSrc: function(item) {
                return item.img[0].description;
            }
        },
        callbacks: {
            imageLoadComplete: function () {
                if ($(this.currItem.el).find("img")[0].title) {
                    $(this.currItem)[0].img[0].title = $(this.currItem.el).find("img")[0].title;
                }
            }
        }
    });
}

/**
 *   @section 8. Magnific Popup
 **/
function magnificPopup() {
    $('.magnificpopup').magnificPopup({
        type:'image',
        image: {
            // options for image content type
            titleSrc: function (item) {
                return item.img[0].alt;
            }
        }
    });
}


//toggle Eyecatcher
function toggleEyecatcher(){
    var toggleElement = jQuery("header .eye-catcher");
    var toggleLink = jQuery(".eye-catcher .toggle");

    toggleLink.click(function() {
        toggleElement.toggle( "slow", function() {
            // Animation complete.
        });
    });
}


// Bootstrap Carousel Swipe Touch
function carouselTouchSwipe(){
    $(".carousel").carousel({
        swipe: 50 // percent-per-second, default is 50. Pass false to disable swipe
    });
}


// Headerslider / Header carousel: carousel indicators in Desktop Version verlinkt
function dataHrefToHref(){

    var screen = $(window)

    if (screen.width() > 992) {
        $('.headerslider .carousel-indicators a').each(function(){
            var aTag = $(this).attr('href');

            $(this).parent().attr('data-href',aTag);

            $("[data-href]").click(function() {
                window.location.href = $(this).attr("data-href");
                return false;
            });
        })
    }
}

/**
 *   @section 5. Funktion Focusfarbe setzen
 **/
function focusHighlighting() {

    var highlight = false;

    $(document.body)
        .on('keydown', function (e) {
            if(highlight === false) {
                var $this = jQuery(this);

                highlight = true;

                // 9 is 'tab'
                if(e.which === 9) {
                    $this.addClass('focus-highlight');
                }
            }
        }).on('mousemove',function (e) {
        if(highlight === true) {
            var $this = jQuery(this);

            highlight = false;
            $this.removeClass('focus-highlight');
        }
    });
}

/**
 *   @section 6. Wenn mobiles Menü geöffnet ist: setze Klassen und Attribute
 **/
function mobileMenuIsOpen(){

    var toggleButton = $('.navbar-toggle'),
        listNoTab = $('.content-total a, .content-total button, .content-total input, .image-header a, .image-header button, .cc_btn_accept_all')
    ;

    toggleButton.on('click', function() {
        $('body').toggleClass('menu-open');
        $('body,html').animate({
            scrollTop: 0
        }, 800);

        // Setze alle antabbaren Elemente außerhalb des mobilen Menüs auf tabindex="-1"
        listNoTab.attr("tabindex","-1");
    })
}

/**
 *   @section 7. Setze aria-label an aside Element mit allen Werten der darin befindlichen h3
 **/
function setAttrToAside(){

    var aside = $('aside'),
        headline = $('h3')

    ;

    aside.each(function() {
        var $this = $(this);

        //Lese pro aside Element die h3 aus und setze Kommas dazwischen
        var aria = $this.find(headline).map(function(){
            return $(this).text();
        }).get().join(',');

        // Setze Attribut aria-label
        $this.attr('aria-label',aria)
    });
}


/**
 *   @section 8. Lösche Attribute aria-expanded von Accordion-Content nach BITV
 **/
function deleteAttrFromAccordion() {

    $('.panel-group').on('hidden.bs.collapse', function () {
        $(this).find('.panel-collapse').removeAttr('aria-expanded')
    });

    $('.panel-group').on('shown.bs.collapse', function () {
        $(this).find('.panel-collapse').removeAttr('aria-expanded')
    });


    $('.collapse').on('hidden.bs.collapse', function () {
        $(this).removeAttr('aria-expanded')
    });

    $('.collapse').on('shown.bs.collapse', function () {
        $(this).removeAttr('aria-expanded')
    });
}

function emptyCookies() {
    var checkboxTracking = $('#tracking'),
        allCookies = localStorage.getItem('dhm-cookie-hint--accept'),
        mediaCookies = localStorage.getItem('dhm-cookie-media--accept'),
        trackingCookies = localStorage.getItem('dhm-cookie-tracking--accept'),
        checkboxMedia = $('#media');

    if (allCookies) {
        $(checkboxTracking).prop('checked', true);
        $(checkboxMedia).prop('checked', true);
    } else if (trackingCookies && !mediaCookies) {
        $(checkboxTracking).prop('checked', true);
        $(checkboxMedia).prop('checked', false);
    } else if (mediaCookies && !trackingCookies) {
        $(checkboxTracking).prop('checked', false);
        $(checkboxMedia).prop('checked', true);
    } else if (mediaCookies && trackingCookies) {
        $(checkboxTracking).prop('checked', true);
        $(checkboxMedia).prop('checked', true);
    } else {
        $(checkboxTracking).prop('checked', false);
        $(checkboxMedia).prop('checked', false);
    }
    setNewCookies();
}

function acceptCookies() {
    if (localStorage.getItem('dhm-cookie-hint--accept')) {
        allowTracking();
        video();
    } else if (localStorage.getItem('dhm-cookie-tracking--accept')) {
        video();
        allowTracking();
    }
    else if (localStorage.getItem('dhm-cookie-media--accept')) {
        // Videos abspielen
        video();
    }else if (localStorage.getItem('dhm-cookie-hint--decline') || localStorage.getItem('dhm-cookie-external--accept')) {
        // Videos abspielen
        video();
    } else {

        var cookieHint = $('#cookieHint');
        cookieHint.css("display", "block");
        $('#tracking').prop('checked', true);
        setNewCookies()
    }
}

function setNewCookies() {
    var cookieHint = $('#cookieHint'),
        cookieHintTracking = $('#cookie-hint-tracking_anchor'),
        cookieHintMedia = $('#cookie-hint-media_anchor'),
        cookieHintEssential = $('#cookie-hint-essential_anchor');

    $('#cookieHint-accept').click( function() {
        localStorage.clear();
        deleteAllCookies();
        // set local storage variable
        localStorage.setItem('dhm-cookie-hint--accept', 'true');

        allowTracking();
        video();
        cookieHint.css("display", "none");
    });

    $('#cookieHint-save-config').click( function () {
        var tracking = document.getElementById('tracking');
        var media = document.getElementById('media');
        localStorage.clear();
        deleteAllCookies();

        if (tracking.checked) {
            allowTracking();
            video();
            localStorage.setItem('dhm-cookie-tracking--accept', 'true');
        }
        if (media.checked) {
            video();
            localStorage.setItem('dhm-cookie-media--accept', 'true');
        }
        if(!media.checked && !tracking.checked) {
            video();
            localStorage.setItem('dhm-cookie-hint--decline', 'true')
        }

        cookieHint.css("display", "none");
    });

    if(!cookiesSet) {
        cookiesSet = true
        cookieHintEssential.click(function() {
            $('#cookie-hint-essential_descprition').toggle(200);
            cookieHintEssential.toggleClass('cookie-hint__anchor--down');
        });
        cookieHintTracking.click( function() {
            $('#cookie-hint-tracking_description').toggle(200);
            cookieHintTracking.toggleClass('cookie-hint__anchor--down');
        });
        cookieHintMedia.click( function() {
            $('#cookie-hint-media_description').toggle(200);
            cookieHintMedia.toggleClass('cookie-hint__anchor--down');
        });
    }
}

// Lade Anbieter zum Tracking
function allowTracking() {

    $('head').append(' <!-- Matomo -->\n' +
        '        <script>\n' +
        '          var _paq = window._paq = window._paq || [];\n' +
        '          /* tracker methods like "setCustomDimension" should be called before "trackPageView" */\n' +
        '          _paq.push([\'trackPageView\']);\n' +
        '          _paq.push([\'enableLinkTracking\']);\n' +
        '          (function() {\n' +
        '            var u="https://www.dhmd.de/matomo/";\n' +
        '            _paq.push([\'setTrackerUrl\', u+\'matomo.php\']);\n' +
        '            _paq.push([\'setSiteId\', \'1\']);\n' +
        '            var d=document, g=d.createElement(\'script\'), s=d.getElementsByTagName(\'script\')[0];\n' +
        '            g.async=true; g.src=u+\'matomo.js\'; s.parentNode.insertBefore(g,s);\n' +
        '          })();\n' +
        '        </script>\n' +
        '        <!-- End Matomo Code -->');
}

function video() {
    var $ext = $('.dhm-video');
    if ($ext.length === 0) {
        return;
    }

    var $videoContainer = $('.xm-media-video__container');
    var acceptedMediaCookies = localStorage.getItem('dhm-cookie-media--accept');
    var acceptedAllCookies = localStorage.getItem('dhm-cookie-hint--accept')

    if(acceptedMediaCookies || acceptedAllCookies) {
        $videoContainer.each(function () {
            var $this = $(this)
            $this.find('figure').addClass('invisible');
            setTimeout(function () {
                videoPlay($this);
            }, 200)
        })
    } else {
        $('.xm-media-video__button', $ext)
            .on('mouseenter focus', function () {
                var $button = $(this);
                $button.addClass('xm-media-video__button--show-hint');
            })
            .on('mouseleave blur', function () {
                var $button = $(this);
                $button.removeClass('xm-media-video__button--show-hint');
            }).on('click touchend', function (e) {
            // e.stopPropagation();

            var $button = $(this),
                $container = $button.closest('.xm-media-video__container', $ext)
            ;

            if (e.type === 'touchend') {
                // show hint/tooltip at first touch ..
                if (!$button.hasClass('xm-media-video__button--show-hint')) {
                    $button.addClass('xm-media-video__button--show-hint');
                } else {
                    // .. at second touch show the video!
                    $button.removeClass('xm-media-video__button--show-hint');
                    videoPlay($container);
                }
            } else {
                videoPlay($container);
            }

            // prevents touch devices to fires 'click' and 'touchend'
            // https://stackoverflow.com/questions/7018919/how-to-bind-touchstart-and-click-events-but-not-respond-to-both#answer-36452427
            return false;
        });

        // on keyup
        $(document).on('keyup', function(event) {
            // press 'esc' button
            if (event.keyCode === 27) {
                // hide 'hint'
                $('.xm-media-video__button').removeClass('xm-media-video__button--show-hint');
            }
        });
    }
}

function videoPlay($container) {
    if ( ! $container.hasClass('xm-media-video--active')) {

        var src = $container.data('src') + '?enablejsapi=1&autoplay=0',
            isIframe = $container.data('is-iframe') || false,
            posterFile = $container.data('poster-file') || '',
            titleVideo = 'Video-Player',
            titleYoutube = 'YouTube Video-Player'
        ;

        $container.addClass('xm-media-video--active');

        if (isIframe){
            $container.html('<iframe src="'+ src +'" title="'+ titleYoutube +'" class="xm-media-video__video" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        }
        else {
            $container.html('<video src="'+ src +'" title="'+ titleVideo +'" class="xm-media-video__video" controls poster="'+ posterFile +'"></video>');
        }
    }
}

function deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}

function jumpToPoll() {
    var poll = document.querySelector('.tx-simplepoll');

    if (window.location.href.indexOf("tx_simplepoll_polllisting") != -1) {
        poll.scrollIntoView(true)
    }
}
